var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 0.0908203C23.2851 0.0908203 30 6.8057 30 15.0908C30 22.5791 24.5156 28.7842 17.3438 29.9092V19.4268H20.8389L21.5039 15.0908H17.3438V12.2783C17.3438 11.889 17.4062 11.5028 17.556 11.1597C17.56 11.1505 17.564 11.1413 17.5682 11.1322C17.5751 11.117 17.5821 11.1018 17.5894 11.0868C17.9102 10.4212 18.5789 9.93457 19.7871 9.93457H21.6797H21.6797V6.24316C21.6797 6.24316 21.5724 6.22485 21.3858 6.19739C20.826 6.11499 19.5527 5.9502 18.3223 5.9502C18.3222 5.9502 18.3222 5.9502 18.3222 5.9502C17.8938 5.9502 17.4839 5.98265 17.0947 6.04679C16.3633 6.16731 15.7047 6.39969 15.1326 6.73882C13.5734 7.66303 12.6562 9.38004 12.6562 11.7861V15.0908H8.84763H8.84761V19.4268H8.84763H12.6562V29.9092C5.48437 28.7842 0 22.5791 0 15.0908C0 6.8057 6.71488 0.0908203 15 0.0908203Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.9763f5f1.svg";
export { ForwardRef as ReactComponent };